import { Form, FormItemProps } from "@p0security/ui";
import classNames from "classnames";

export const standardFormItemCols = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
  colon: false,
};

export const standardSubmitButtonCol = {
  wrapperCol: { offset: 8, span: 16 },
};

/** A `Form.Item` whose label wraps instead of running off the end of its column. */
export const StyledFormItem: React.FC<FormItemProps> = ({
  className,
  ...props
}) => (
  <Form.Item
    className={classNames(
      "[&_.ant-form-item-label]:whitespace-normal!",
      className
    )}
    {...props}
  />
);
